import React, { useState, useEffect } from "react";
import { Layout as AntLayout } from "antd";
import Header from "./Header";
import Sidebar from "./Sidebar";

const { Content } = AntLayout;

const MOBILE_BREAKPOINT = 992;

const Layout = ({ children }) => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);

  useEffect(() => {
    const checkMobile = () => {
      if (window.innerWidth <= MOBILE_BREAKPOINT) {
        setIsSidebarVisible(false);
      }
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarVisible((prev) => !prev);
  };

  return (
    <AntLayout style={{ minHeight: "100vh" }}>
      <Sidebar
        isSidebarVisible={isSidebarVisible}
        onCloseSidebar={() => setIsSidebarVisible(false)}
      />
      <AntLayout style={{ marginLeft: isSidebarVisible ? 300 : 0, minHeight: "100vh" }}>
        <Header
          isSidebarVisible={isSidebarVisible}
          toggleSidebar={toggleSidebar}
        />
        <Content
          className="main-content-wrap"
          style={{
            margin: 0,
            minHeight: "calc(100vh - 64px)",
            background: "#f5f5f5",
            padding: 24,
          }}
        >
          {children}
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
